module.exports = __webpack_public_path__ + "static/media/astro_logo.ea937e07.png";